import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Case } from '@models';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class CaseService {
  private http = inject(HttpClient);

  create(c: Case) {
    return this.http.post<Case>(`${environment.kinkoHost}/case/`, c, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  get(id: string) {
    return this.http.get<Case>(`${environment.kinkoHost}/case/${id}`);
  }

  update(c: Case) {
    return this.http.put<Case>(`${environment.kinkoHost}/case/${c.id}`, c, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }

  delete(id: string) {
    return this.http.delete<void>(`${environment.kinkoHost}/case/${id}`);
  }
}
